export const ordering = {
    ascend: 'asc',
    descend: 'desc',
};
